var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-secondary-table-layout',{attrs:{"card-title":_vm.$tc('product.deliveredPart', 2)},scopedSlots:_vm._u([{key:"button",fn:function(){return [(_vm.isAdmin)?_c('base-new-outlined-button',{attrs:{"to":{
        name: _vm.name,
        params: { orderId: _vm.orderId }
      }}},[_vm._v(_vm._s(_vm.$tc('product.part', 1)))]):_vm._e()]},proxy:true}])},[_c('ItemUnitsOnOrderIndexTable',{attrs:{"order-id":_vm.orderId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }